import React, { useState, useEffect, useContext } from "react";
import { Navigate } from 'react-router-dom';
import axios from "axios";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomCardCharts from "components/CustomCardCharts/CustomCardCharts";
import { CustomSelect } from "components/Input/Index.js";
import { dashboardDateChoiceData, roitypesData } from "variables/lists/planActions";
import { criticityData, statusData } from "variables/lists/action";
import { ActionPlansContext } from "context/ActionPlansContext";
import { getActionPlanDashboard } from "services/ConfigServices";
import UserService from "services/UserService";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import moment from "moment";
import styled from "styled-components";
import DataTable from "react-data-table-component";
import 'moment/locale/fr';
import uuid from "react-uuid";

const unitsData = [
  { name: "kwh", id: "kWh éco ou m3" },
  { name: "eco", id: "€ éco" },
  { name: "co2", id: "kg éq CO2 éco" },
  { name: "investissement", id: "€ investissement" },
];
const GroupCell = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;
const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;


export default function Analysis() {

  const appContext = useContext(ActionPlansContext);
  const advancedSearchContext = useContext(AdvancedSearchContext);
  const { groupInfoListById, setPage } = advancedSearchContext;
  const { actionPlans, setActionPlans } = appContext;

  const [dataactions, setDataactions] = useState([]);
  const [daterange, setDaterange] = useState("today")

  const [datatimelineinvestprojected, setDatatimelineinvestprojected] = useState([]);
  const [datatimelineinvestreal, setDatatimelineinvestreal] = useState([]);
  const [datatimelinesavekwhprojected, setDatatimelinesavekwhprojected] = useState([]);
  const [datatimelinesavekwhreal, setDatatimelinesavekwhreal] = useState([]);
  const [datatimelinesavem3projected, setDatatimelinesavem3projected] = useState([]);
  const [datatimelinesavem3real, setDatatimelinesavem3real] = useState([]);
  const [datatimelinesaveeurosprojected, setDatatimelinesaveeurosprojected] = useState([]);
  const [datatimelinesaveeurosreal, setDatatimelinesaveeurosreal] = useState([]);
  const [datatimelinesaveco2projected, setDatatimelinesaveco2projected] = useState([]);
  const [datatimelinesaveco2real, setDatatimelinesaveco2real] = useState([]);
  const [datatimelineprojecteddisplayed, setDatatimelineprojecteddisplayed] = useState([]);
  const [datatimelinerealdisplayed, setDatatimelinerealdisplayed] = useState([]);
  const [mindatetime, setMindatetime] = useState("");
  const [maxdatetime, setMaxdatetime] = useState("");
  const [timelineunity, setTimelineunity] = useState("");
  const [timelineunitaction, setTimelineunitaction] = useState("");

  const [projectedinvest, setProjectedinvest] = useState("");
  const [realinvest, setRealinvest] = useState("");
  const [leftinvest, setLeftinvest] = useState("");

  const [savingstypedata, setSavingstypedata] = useState([]);
  const [savingstype, setSavingstype] = useState('');
  const [datasavings, setDatasavings] = useState({});
  const [savingsprojected, setSavingsprojected] = useState([]);
  const [savingsreal, setSavingsreal] = useState([]);
  const [savingsleft, setSavingsleft] = useState([]);
  const [savingscategories, setSavingscategories] = useState([]);
  const [energyavailable, setEnergyavailable] = useState([]);
  const [roitype, setRoitype] = useState('');
  const [dataperformance, setDataperformance] = useState([]);
  const [timelinefiltertype, setTimelinefiltertype] = useState('');
  const [timelinefiltertypedata, setTimelinefiltertypedata] = useState([]);

  const [redirState, setRedirState] = useState(false);
  const [actionId, setActionId] = useState("");
  const [actionName, setActionName] = useState("");
  let redirecting = redirState ? (
    <Navigate
      push
      to={{
        pathname: "/admin/actionplans/selectedplanaction/selectedaction/",
        state: {
          planActionId: actionPlans.id,
          planActionName: actionPlans.parameters.general.name,
          actionId,
          actionName,
          groupParent: actionPlans.parameters.general.groups,
          actionPlansParameters: actionPlans.parameters,
        },
      }}
    />
  ) : (
    ""
  );

  const handleDaterangeChange = (event) => {
    let daterangetmp = event.target.value;
    if (daterangetmp === 'endofyear') {
      setMaxdatetime(moment().month(12).day(31).hour(23).minute(59).second(59).utc().unix() * 1000);
    }
    else if (daterangetmp === 'today') {
      setMaxdatetime(moment().utc().unix() * 1000);
    }
    else if (daterangetmp === '3') {
      setMaxdatetime(moment().add(3, 'year').month(12).day(31).hour(23).minute(59).second(59).utc().unix() * 1000);
    }
    else if (daterangetmp === '5') {
      setMaxdatetime(moment().add(5, 'year').month(12).day(31).hour(23).minute(59).second(59).utc().unix() * 1000);
    }
    else if (daterangetmp === '10') {
      setMaxdatetime(moment().add(10, 'year').month(12).day(31).hour(23).minute(59).second(59).utc().unix() * 1000);
    }
    else if (daterangetmp === '20') {
      setMaxdatetime(moment().add(20, 'year').month(12).day(31).hour(23).minute(59).second(59).utc().unix() * 1000);
    }
    else if (daterangetmp === '30') {
      setMaxdatetime(moment().add(30, 'year').month(12).day(31).hour(23).minute(59).second(59).utc().unix() * 1000);
    }
    setDaterange(event.target.value);
  };
  const handleSavingsTypeChange = (event) => {
    setSavingstype(event.target.value);
  };
  const handleRoiTypeChange = (event) => {
    setSavingstype(event.target.value);
  };
  const handleTimelinefiltertypeChange = (event) => {
    // console.log(event);
    setTimelinefiltertype(event.target.value);
  }

  useEffect(() => {
    setMaxdatetime(moment().utc().unix() * 1000);
    axios
      .get(getActionPlanDashboard(actionPlans.id), {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      })
      .then((res) => {
        console.log(res.data);
        console.log(actionPlans);
        let dataactionstmp = res.data.actions;
        setDataactions(dataactionstmp);

        //graph invest
        let projectedinvesttmp = 0;
        let realinvesttmp = 0;
        let leftinvesttmp = 0;

        //timline
        let mindatetimetmp = moment().utc().unix() * 1000; //now
        let datatimelineinvestprojectedtmp = [];
        let datatimelineinvestrealtmp = [];
        let datatimelinesavekwhprojectedtmp = [];
        let datatimelinesavekwhrealtmp = [];
        let datatimelinesavem3projectedtmp = [];
        let datatimelinesavem3realtmp = [];
        let datatimelinesaveeurosprojectedtmp = [];
        let datatimelinesaveeurosrealtmp = [];
        let datatimelinesaveco2projectedtmp = [];
        let datatimelinesaveco2realtmp = [];

        res.data.actions.map((action) => {
          //graphinvest
          let costset = false;
          if (action.parameters?.results?.cost) {
            realinvesttmp += Number(action.parameters.results.cost);
            costset = true;
          }
          if (action.parameters?.projections?.investment) {
            projectedinvesttmp += Number(action.parameters.projections.investment);
            if (!costset)
              leftinvesttmp += Number(action.parameters.projections.investment); //si on a pas encore mis le cout réél, il reste le cout prévu
          }
          //timeline
          if (action.parameters?.general) {
            if (action.parameters.general.wantedstartdate
              && moment(action.parameters.general.wantedstartdate).isValid()
              && moment(action.parameters.general.wantedstartdate).hour(10).utc().date(1).hour(0).minute(0).second(0).unix() * 1000 < mindatetimetmp) {
              mindatetimetmp = moment(action.parameters.general.wantedstartdate).hour(10).utc().date(1).hour(0).minute(0).second(0).unix() * 1000;
            }
            if (action.parameters.general.realstartdate
              && moment(action.parameters.general.realstartdate).isValid()
              && moment(action.parameters.general.realstartdate).hour(10).utc().date(1).hour(0).minute(0).second(0).unix() * 1000 < mindatetimetmp) {
              mindatetimetmp = moment(action.parameters.general.realstartdate).hour(10).utc().date(1).hour(0).minute(0).second(0).unix() * 1000;
            }
            if (action.parameters.general.wantedenddate
              && moment(action.parameters.general.wantedenddate).isValid()
              && moment(action.parameters.general.wantedenddate).hour(10).utc().date(1).hour(0).minute(0).second(0).unix() * 1000 < mindatetimetmp) {
              mindatetimetmp = moment(action.parameters.general.wantedenddate).hour(10).utc().date(1).hour(0).minute(0).second(0).unix() * 1000;
            }
            if (action.parameters.general.realenddate
              && moment(action.parameters.general.realenddate).isValid()
              && moment(action.parameters.general.realenddate).hour(10).utc().date(1).hour(0).minute(0).second(0).unix() * 1000 < mindatetimetmp) {
              mindatetimetmp = moment(action.parameters.general.realenddate).hour(10).utc().date(1).hour(0).minute(0).second(0).unix() * 1000;
            }
          }
          //timeline invest
          if (action.parameters?.projections?.investment
            && action.parameters?.general?.wantedstartdate
            && moment(action.parameters.general.wantedstartdate).isValid()) {
            datatimelineinvestprojectedtmp.push({
              x: moment(action.parameters.general.wantedstartdate,).hour(10).utc().date(1).hour(0).minute(0).second(0).unix() * 1000, //hour(10) is arbitratry to make sure that switching in UTC does not change date
              actionvalue: Number(action.parameters.projections.investment), name: action.parameters.general.name, id: action.id
            })
          }
          if (action.parameters?.results?.cost
            && action.parameters?.general?.realstartdate
            && moment(action.parameters.general.realstartdate).isValid()) {
            datatimelineinvestrealtmp.push({
              x: moment(action.parameters.general.realstartdate).hour(10).utc().date(1).hour(0).minute(0).second(0).unix() * 1000,
              actionvalue: Number(action.parameters.results.cost), name: action.parameters.general.name, id: action.id
            })
          }

          //timeline savings
          if (action.parameters?.projections?.savings
            && action.parameters?.general?.wantedenddate
            && moment(action.parameters.general.wantedenddate).isValid()) {
            let xaction = moment(action.parameters.general.wantedstartdate,).add(1, 'month').hour(10).utc().date(1).hour(0).minute(0).second(0).unix() * 1000; //hour(10) is arbitratry to make sure that switching in UTC does not change date
            action.parameters.projections.savings.map((energy) => {
              if (energy.energy === 'water' && energy.consumption) {
                datatimelinesavem3projectedtmp.push({
                  x: xaction,
                  actionvalue: Number(energy.consumption), name: action.parameters.general.name, id: action.id
                });
              }
              else if (energy.consumption) {
                datatimelinesavekwhprojectedtmp.push({
                  x: xaction,
                  actionvalue: Number(energy.consumption), name: action.parameters.general.name, id: action.id
                });
              }
              if (energy.euros) {
                datatimelinesaveeurosprojectedtmp.push({
                  x: xaction,
                  actionvalue: Number(energy.euros), name: action.parameters.general.name, id: action.id
                });
              }
              if (energy.co2) {
                datatimelinesaveco2projectedtmp.push({
                  x: xaction,
                  actionvalue: Number(energy.co2), name: action.parameters.general.name, id: action.id
                });
              }
            });
          }
          if (action.parameters?.results?.savings
            && action.parameters?.general?.realenddate
            && moment(action.parameters.general.realenddate).isValid()) {
            let xaction = moment(action.parameters.general.realenddate,).add(1, 'month').hour(10).utc().date(1).hour(0).minute(0).second(0).unix() * 1000; //hour(10) is arbitratry to make sure that switching in UTC does not change date
            action.parameters.results.savings.map((energy) => {
              if (energy.energy === 'water' && energy.consumption) {
                datatimelinesavem3realtmp.push({
                  x: xaction,
                  actionvalue: Number(energy.consumption), name: action.parameters.general.name, id: action.id
                });
              }
              else if (energy.consumption) {
                datatimelinesavekwhrealtmp.push({
                  x: xaction,
                  actionvalue: Number(energy.consumption), name: action.parameters.general.name, id: action.id
                });
              }
              if (energy.euros) {
                datatimelinesaveeurosrealtmp.push({
                  x: xaction,
                  actionvalue: Number(energy.euros), name: action.parameters.general.name, id: action.id
                });
              }
              if (energy.co2) {
                datatimelinesaveco2realtmp.push({
                  x: xaction,
                  actionvalue: Number(energy.co2), name: action.parameters.general.name, id: action.id
                });
              }
            });
          }
        });

        let datatimelineinvestprojectedtmpfinal = completeinvest(datatimelineinvestprojectedtmp);
        let datatimelineinvestrealtmpfinal = completeinvest(datatimelineinvestrealtmp);
        let datatimelinesavekwhprojectedtmpfinal = completesavings(datatimelinesavekwhprojectedtmp);
        let datatimelinesavekwhrealtmpfinal = completesavings(datatimelinesavekwhrealtmp);
        let datatimelinesavem3projectedtmpfinal = completesavings(datatimelinesavem3projectedtmp);
        let datatimelinesavem3realtmpfinal = completesavings(datatimelinesavem3realtmp);
        let datatimelinesaveeurosprojectedtmpfinal = completesavings(datatimelinesaveeurosprojectedtmp);
        let datatimelinesaveeurosrealtmpfinal = completesavings(datatimelinesaveeurosrealtmp);
        let datatimelinesaveco2projectedtmpfinal = completesavings(datatimelinesaveco2projectedtmp);
        let datatimelinesaveco2realtmpfinal = completesavings(datatimelinesaveco2realtmp);

        setProjectedinvest(projectedinvesttmp);
        setRealinvest(realinvesttmp);
        setLeftinvest(leftinvesttmp);

        setMindatetime(mindatetimetmp);
        setDatatimelineinvestprojected(datatimelineinvestprojectedtmpfinal);
        setDatatimelineinvestreal(datatimelineinvestrealtmpfinal);
        setDatatimelinesavekwhprojected(datatimelinesavekwhprojectedtmpfinal);
        setDatatimelinesavekwhreal(datatimelinesavekwhrealtmpfinal);
        setDatatimelinesavem3projected(datatimelinesavem3projectedtmpfinal);
        setDatatimelinesavem3real(datatimelinesavem3realtmpfinal);
        setDatatimelinesaveeurosprojected(datatimelinesaveeurosprojectedtmpfinal);
        setDatatimelinesaveeurosreal(datatimelinesaveeurosrealtmpfinal);
        setDatatimelinesaveco2projected(datatimelinesaveco2projectedtmpfinal);
        setDatatimelinesaveco2real(datatimelinesaveco2realtmpfinal);



      });

  }, []);

  const completeinvest = (sourcearray) => {
    console.log('completeinvest');
    sourcearray = sourcearray.sort((a, b) => a.x - b.x);
    let total = 0;
    let newarray = [];
    let lastaction = {};
    sourcearray.map((action) => {
      total = total + action.actionvalue;
      let actions = [];
      if (lastaction.x && lastaction.x == action.x) {
        actions = [...lastaction.actions];
        newarray.splice(newarray.findIndex((action) => action.actionid === lastaction.actionid), 1);
      }
      actions.push({ actionvalue: action.actionvalue, name: action.name });
      let newaction = {
        x: action.x, y: total,
        actions: actions,
        actionid: action.id,
        key: uuid(),
      };
      lastaction = { ...newaction };
      newarray.push(newaction);
    });
    newarray.push({ x: moment().add(30, 'year').month(12).day(31).hour(23).minute(59).second(59).utc().unix() * 1000, y: total,key: uuid(), }) //to close at max date
    return newarray;
  }

  const completesavings = (sourcearray) => {
    console.log('completesavings');
    sourcearray = sourcearray.sort((a, b) => a.x - b.x);
    let newarray = [];
    let total = 0;
    let monthlycumul = 0;
    let lastaction = {};
    sourcearray.map((action) => {
      if (lastaction.x && lastaction.x < action.x) { //complete monthly savings
        let start = moment(lastaction.x).add(1, 'month').hour(10).utc().hour(0).unix() * 1000; //begin 1 month after last action
        while (start < action.x) {
          monthlycumul = monthlycumul + (total / 12);
          newarray.push({ x: start, y: monthlycumul });
          start = moment(start).add(1, 'month').hour(10).utc().hour(0).unix() * 1000;
        }
      }
      total = total + action.actionvalue;
      monthlycumul = monthlycumul + (total / 12);
      let actions = [];
      if (lastaction.x && lastaction.x == action.x) {
        actions = [...lastaction.actions];
        newarray.splice(newarray.findIndex((action) => action.actionid === lastaction.actionid), 1);
      }
      actions.push({ actionvalue: action.actionvalue, name: action.name });
      let newaction = {
        x: action.x, y: monthlycumul,
        actions: actions,
        actionid: action.id,
      };
      lastaction = { ...newaction };
      newarray.push(newaction);
    });
    let start = moment(lastaction.x).add(1, 'month').hour(10).utc().hour(0).unix() * 1000; //begin 1 month after last action
    let end = moment().add(30, 'year').month(12).day(31).hour(23).minute(59).second(59).utc().unix() * 1000;
    while (start < end) {
      monthlycumul = monthlycumul + (total / 12);
      newarray.push({ x: start, y: monthlycumul });
      start = moment(start).add(1, 'month').hour(10).utc().hour(0).unix() * 1000;
    }
    return newarray;
  }

  useEffect(() => {
    let energyavailabletmp = [];

    if (actionPlans?.parameters?.goals) {
      const goals = actionPlans.parameters.goals;
      if (goals.electricityobjconsumption?.value)
        energyavailabletmp.push('electricity');
      if (goals.gasobjconsumption?.value)
        energyavailabletmp.push('gas');
      if (goals.waterobjconsumption?.value)
        energyavailabletmp.push('water');
      if (goals.propaneobjconsumption?.value)
        energyavailabletmp.push('propane');
      if (goals.fuelobjconsumption?.value)
        energyavailabletmp.push('fuel');
      if (goals.heatnetworkobjconsumption?.value)
        energyavailabletmp.push('heat');
      if (goals.coldnetworkobjconsumption?.value)
        energyavailabletmp.push('cold');
    }
    setEnergyavailable(energyavailabletmp);
    let savingstypedatatmp = [];
    let timelinefiltertypetmpdata = [];
    let tmptimelinefiltertype = "";
    let tmpsavingstype = "";
    if (energyavailabletmp.includes("electricity") ||
      energyavailabletmp.includes("gas") ||
      energyavailabletmp.includes("propane") ||
      energyavailabletmp.includes("fuel") ||
      energyavailabletmp.includes("heat") ||
      energyavailabletmp.includes("cold"))
      timelinefiltertypetmpdata.push({ id: 'kwh', name: 'Economies kWh' });
    savingstypedatatmp.push({ id: 'kwh', name: 'kWh' });
    if (energyavailabletmp.includes("water")) {
      timelinefiltertypetmpdata.push({ id: 'm3', name: 'Economies m3' });
      savingstypedatatmp.push({ id: 'm3', name: 'm3' });
    }
    if (energyavailabletmp.length > 0) {
      savingstypedatatmp.push({ id: 'euros', name: '€' });
      savingstypedatatmp.push({ id: 'co2', name: 'CO2' });
      timelinefiltertypetmpdata.push({ id: 'euros', name: 'Economies €' });
      timelinefiltertypetmpdata.push({ id: 'co2', name: 'Economies CO2' });
      timelinefiltertypetmpdata.push({ id: 'invest', name: 'Investissement €' });
      tmpsavingstype = savingstypedatatmp[0].id;
      tmptimelinefiltertype = timelinefiltertypetmpdata[0].id;
    }

    setSavingstype(tmpsavingstype);
    setSavingstypedata(savingstypedatatmp);
    setTimelinefiltertypedata(timelinefiltertypetmpdata);
    setTimelinefiltertype(tmptimelinefiltertype);
    setRoitype('real');
  }, [actionPlans]);

  useEffect(() => {
    //we will make deep copy because highcharts mess with object values
    let newdataprojected = [];
    let newdatareal = [];
    if (timelinefiltertype === 'invest') {
      newdataprojected = JSON.parse(JSON.stringify(datatimelineinvestprojected));
      newdatareal = JSON.parse(JSON.stringify(datatimelineinvestreal));
      setTimelineunity('€');
      setTimelineunitaction('€');
    }
    else if (timelinefiltertype === 'kwh') {
      newdataprojected = JSON.parse(JSON.stringify(datatimelinesavekwhprojected));
      newdatareal = JSON.parse(JSON.stringify(datatimelinesavekwhreal));
      setTimelineunity('kWh');
      setTimelineunitaction('kWh/an');
    }
    else if (timelinefiltertype === 'm3') {
      newdataprojected = JSON.parse(JSON.stringify(datatimelinesavem3projected));
      newdatareal = JSON.parse(JSON.stringify(datatimelinesavem3real));
      setTimelineunity('m3');
      setTimelineunitaction('m3/an');
    }
    else if (timelinefiltertype === 'co2') {
      newdataprojected = JSON.parse(JSON.stringify(datatimelinesaveco2projected));
      newdatareal = JSON.parse(JSON.stringify(datatimelinesaveco2real));
      setTimelineunity('kgEqCO2');
      setTimelineunitaction('kgEqCO2/an');
    }
    else if (timelinefiltertype === 'euros') {
      newdataprojected = JSON.parse(JSON.stringify(datatimelinesaveeurosprojected));
      newdatareal = JSON.parse(JSON.stringify(datatimelinesaveeurosreal));
      setTimelineunity('€');
      setTimelineunitaction('€/an');
    }
    setDatatimelineprojecteddisplayed(newdataprojected);
    setDatatimelinerealdisplayed(newdatareal);
  }, [timelinefiltertype]);

  console.log(datatimelineprojecteddisplayed);

  useEffect(() => {
    let tmpsavingsprojected = [];
    let tmpsavingsreal = [];
    let tmpsavingsleft = [];
    let tmpsavingscategories = [];
    if (savingstype === 'm3') {
      if (energyavailable.includes("water")) {
        tmpsavingscategories.push('water');
        tmpsavingsprojected.push(datasavings?.water?.m3?.projected || 0);
        tmpsavingsreal.push(datasavings?.water?.m3?.real || 0);
        tmpsavingsleft.push(datasavings?.water?.m3?.left || 0);
      }
    }
    else if (savingstype === 'kwh') {
      energyavailable.map((energy) => {
        if (energy !== 'water') {
          tmpsavingscategories.push(energy);
          tmpsavingsprojected.push(datasavings?.[energy]?.kwh?.projected || 0);
          tmpsavingsreal.push(datasavings?.[energy]?.kwh?.real || 0);
          tmpsavingsleft.push(datasavings?.[energy]?.kwh?.left || 0);
        }
      });
    }
    else if (savingstype === 'euros') {
      energyavailable.map((energy) => {
        tmpsavingscategories.push(energy);
        tmpsavingsprojected.push(datasavings?.[energy]?.euros?.projected || 0);
        tmpsavingsreal.push(datasavings?.[energy]?.euros?.real || 0);
        tmpsavingsleft.push(datasavings?.[energy]?.euros?.left || 0);
      });
    }
    else if (savingstype === 'co2') {
      energyavailable.map((energy) => {
        tmpsavingscategories.push(energy);
        tmpsavingsprojected.push(datasavings?.[energy]?.co2?.projected || 0);
        tmpsavingsreal.push(datasavings?.[energy]?.co2?.real || 0);
        tmpsavingsleft.push(datasavings?.[energy]?.co2?.left || 0);
      });
    }
    setSavingscategories(tmpsavingscategories);
    setSavingsprojected(tmpsavingsprojected);
    setSavingsreal(tmpsavingsreal);
    setSavingsleft(tmpsavingsleft);

  }, [savingstype, datasavings]);


  const optionsConsoAnnuelle = {
    chart: {
      zoomType: "xy",
      // events: {
      //   load: onChartLoad
      // }
    },
    boost: {
      useGPUTranslations: true,
    },
    xAxis: {
      type: 'datetime',
      min: mindatetime || moment().utc().unix() * 1000,
      max: maxdatetime || moment().utc().unix() * 1000,
      tickInterval: 2592000000, //month
      labels: {
        align: 'left'
      },
      plotLines: [{
        value: 1665133144000,
        dashStyle: 'dash',
        width: 1,
        color: '#d33'
      }]
    },
    title: {
      text: ''
    },
    credits: {
      enabled: false
    },
    tooltip: {
      style: {
        width: '250px'
      }
    },
    yAxis: [{
      title: {
        text: timelineunity
      },
      gridLineWidth: 0
    }],
    plotOptions: {
      series: {
        marker: {
          enabled: false,
          symbol: 'circle',
          radius: 2
        },
        fillOpacity: 0.5
      },
      flags: {
        tooltip: {
          xDateFormat: '%B %e, %Y'
        },
        accessibility: {
          point: {
            valueDescriptionFormat: '{xDescription}. {point.title}: {point.text}.'
          }
        }
      }
    },
    tooltip: {
      shared: false,
      formatter: function (chart) {
         //console.log(this);
        let s = '<b>' + moment(this.x).utc().format("MMMM YYYY") + '</b><br/>';
        if (this.point.actions) {
          this.point.actions.map((action) => {
            s += '' + action.name + ' : ' + action.actionvalue + ' ' + timelineunitaction + '<br/>';
          });
        }
        s += '<h4><b>Total : ' + this.y + ' ' + timelineunity + '</b></h4>';
        return s;
      },
    },//Math.round(this.y * 100) / 100
    series: [
      {
        boostThreshold: 0,
        name: 'Projections',
        id: 'projection',
        type: 'area',
        step: 'left',
        data: datatimelineprojecteddisplayed
      },
      {
        boostThreshold: 0,
        name: 'Réels',
        id: 'current',
        type: 'area',
        step: 'left',
        data: datatimelinerealdisplayed
      }
    ]
  };


  const optionsInvest = {
    credits: {
      enabled: false,
    },
    chart: {
      type: "column",
    },

    title: {
      text: "",
    },

    xAxis: {
      categories: [""],
    },

    yAxis: {
      allowDecimals: false,
      min: 0,
      title: {
        text: "",
      },
    },

    tooltip: {
      formatter: function () {
        return (
          "<b>" +
          this.x +
          "</b><br/>" +
          this.series.name +
          ": " +
          new Intl.NumberFormat('fr-FR').format(this.y) + " €" +
          "<br/>" +
          "Total: " +
          new Intl.NumberFormat('fr-FR').format(this.point.stackTotal) + " €"
        );
      },
    },

    plotOptions: {
      column: {
        stacking: "normal",
      },
    },

    series: [
      {
        name: "Investissement de départ projeté",
        data: [projectedinvest],
        stack: "male",
      },
      {
        name: "Investissement projeté restant",
        data: [leftinvest],
        stack: "female",
      },
      {
        name: "Investissement réel en cours",
        data: [realinvest],
        stack: "female",
      },
    ],
  };

  const optionsSavings = {
    credits: {
      enabled: false,
    },
    chart: {
      type: "column",
    },

    title: {
      text: "",
    },

    xAxis: {
      categories: savingscategories,
    },

    yAxis: {
      allowDecimals: false,
      min: 0,
      title: {
        text: "",
      },
    },

    tooltip: {
      formatter: function () {
        return (
          "<b>" +
          this.x +
          "</b><br/>" +
          this.series.name +
          ": " +
          this.y +
          "<br/>" +
          "Total: " +
          this.point.stackTotal
        );
      },
    },

    plotOptions: {
      column: {
        stacking: "normal",
      },
    },

    series: [
      {
        name: "Economies de départ projetées",
        data: [savingsprojected],
        stack: "projected",
      },
      {
        name: "Economies réelles en cours",
        data: [savingsreal],
        stack: "current",
      },
      {
        name: "Economies projetées restant",
        data: [savingsleft],
        stack: "current",
      },
    ],
  };

  const optionsPerformance = {
    credits: {
      enabled: false,
    },
    chart: {
      type: "bubble",
      plotBorderWidth: 1,
      zoomType: "xy",
    },
    legend: {
      enabled: false,
    },
    title: {
      text: "",
    },
    xAxis: {
      gridLineWidth: 1,
      title: {
        text: "Economies",
      },
      labels: {
        format: "{value} €",
      },
    },

    yAxis: {
      startOnTick: false,
      endOnTick: false,
      title: {
        text: "Investissement",
      },
      labels: {
        format: "{value} €",
      },
      maxPadding: 0.2,
    },

    tooltip: {
      followPointer: true,
      formatter: function () {
        return (
          "<b>" +
          this.name +
          "</b><br/>Economies : " +
          this.x + " €<br/>Investissement : " +
          this.y + " €<br/>Criticité : " +
          criticityData.find((x) => x.id == this.z)?.name || ""
        );
      },
    },

    plotOptions: {
      series: {
        dataLabels: {
          enabled: false,
          format: "{point.name}",
        },
      },
    },

    series: [
      {
        data: dataperformance,
      },
    ],
  };

  const columnsactions = [
    {
      name: "Nom",
      selector: (row) => row.parameters?.general?.name,
      sortable: true,
    },
    {
      name: "Statut",
      selector: (row) => row.parameters?.general?.status,
      sortable: true,
      cell: (row) =>
        row.parameters?.general?.status == "creation" ? (
          <div style={{ color: "#849191", fontWeight: "bold" }}>
            {statusData.find((x) => x.id == "creation").name}
          </div>
        ) : row.parameters?.general?.status == "pending" ? (
          <div style={{ color: "#E3A322", fontWeight: "bold" }}>
            {statusData.find((x) => x.id == "pending").name}
          </div>
        ) : row.parameters?.general?.status == "inprogress" ? (
          <div style={{ color: "#008083", fontWeight: "bold" }}>
            {statusData.find((x) => x.id == "inprogress").name}
          </div>
        ) : row.parameters?.general?.status == "standby" ? (
          <div style={{ color: "#FF8E55", fontWeight: "bold" }}>
            {statusData.find((x) => x.id == "standby").name}
          </div>
        ) : row.parameters?.general?.status == "finished" ? (
          <div style={{ color: "#91C73C", fontWeight: "bold" }}>
            {statusData.find((x) => x.id == "finished").name}
          </div>
        ) : (
          <div style={{ color: "#FF432D", fontWeight: "bold" }}></div>
        ),
    },
    {
      name: "Investissement prévu €",
      selector: (row) => row.parameters?.projections?.investment,
      sortable: true,
      maxWidth: "10rem",
      cell: (row) => row.parameters?.projections?.investment ? new Intl.NumberFormat('fr-FR').format(row.parameters?.projections?.investment) : ""
    },
    {
      name: "Investissement réel €",
      selector: (row) => row.parameters?.results?.cost,
      sortable: true,
      maxWidth: "10rem",
      cell: (row) => row.parameters?.results?.cost ? new Intl.NumberFormat('fr-FR').format(row.parameters?.results?.cost) : ""
    },
    {
      name: "Economies prévues €/an",
      selector: (row) => row.lastvalue,
      sortable: true,
      maxWidth: "10rem",
      cell: (row) => row.lastvalue ? new Intl.NumberFormat('fr-FR').format(row.lastvalue) : ""
    },
    {
      name: "Economies réelles €/an",
      selector: (row) => row.lastvalue,
      sortable: true,
      maxWidth: "10rem",
      cell: (row) => row.lastvalue ? new Intl.NumberFormat('fr-FR').format(row.lastvalue) : ""
    }
  ];


  return (
    <>
      <GridContainer>
        <GridItem xs={12} sm={12} md={4} lg={4}>
          <CustomSelect
            inputTitle={"Date de fin/ période prédéfinie"}
            selectValue={daterange}
            handleSelectValueChange={handleDaterangeChange}
            data={dashboardDateChoiceData}
            name="date"
          />
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12} lg={12} xl={12}>
          <CustomCardCharts
            switchButton={
              <CustomSelect
                selectValue={timelinefiltertype}
                handleSelectValueChange={handleTimelinefiltertypeChange}
                data={timelinefiltertypedata}
                name="timelinetype"
              />
            }
            cardTitle={"Suivi"}
            cardNumber={""}
            graphic={
              <HighchartsReact
                containerProps={{
                  style: { height: "26rem", width: "100%" },
                }}
                highcharts={Highcharts}
                options={optionsConsoAnnuelle}
              />
            }
          />
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={12} md={6} lg={3} xl={3}>
          <CustomCardCharts
            switchButton={
              <CustomSelect
                selectValue={"euros"}
                data={[{ name: '€', id: 'euros' }]}
                name="invest"
              />
            }
            cardTitle={"Suivi des investissements"}
            cardNumber={realinvest ? new Intl.NumberFormat('fr-FR').format(realinvest) + " €" : ""}
            graphic={
              <HighchartsReact
                containerProps={{
                  style: { height: "20rem", width: "100%" },
                }}
                highcharts={Highcharts}
                options={optionsInvest}
              />
            }
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={6} lg={6} xl={6}>
          <CustomCardCharts
            switchButton={
              <CustomSelect
                selectValue={savingstype}
                handleSelectValueChange={handleSavingsTypeChange}
                data={savingstypedata}
                name="units"
              />
            }
            cardTitle={"Suivi des objectifs"}
            cardNumber={savingstype === 'kwh' ? datasavings?.kwh?.real || "" + " kWh/an" :
              savingstype === 'm3' ? datasavings?.m3?.real || "" + " m3/an" :
                savingstype === 'euros' ? datasavings?.euros?.real || "" + " €/an" :
                  datasavings?.co2?.real || "" + " kgeqco2/an"}
            graphic={
              <HighchartsReact
                containerProps={{
                  style: { height: "20rem", width: "100%" },
                }}
                highcharts={Highcharts}
                options={optionsSavings}
              />
            }
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={6} lg={3} xl={3}>
          <CustomCardCharts
            switchButton={
              <CustomSelect
                selectValue={roitype}
                handleSelectValueChange={handleRoiTypeChange}
                data={roitypesData}
                name="roi"
              />
            }
            cardTitle={"Performance des actions"}
            cardNumber={""}
            graphic={
              <HighchartsReact
                containerProps={{
                  style: { height: "20rem", width: "100%" },
                }}
                highcharts={Highcharts}
                options={optionsPerformance}
              />
            }
          />
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12} lg={12} xl={12}>
          <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
            noDataComponent={<NoData>Aucun équipement à afficher</NoData>}
            noHeader={true}
            columns={columnsactions}
            persistTableHead
            pagination
            subHeader
            highlightOnHover
            pointerOnHover
            onRowClicked={(row) => {
              console.log(row.id);
              setActionId(row.id);
              setActionName(row.parameters.general.name);
              setRedirState(true);
            }}
            //dense
            paginationComponentOptions={{
              noRowsPerPage: false,
              rowsPerPageText: "Actions par page",
              rangeSeparatorText: "sur",
              selectAllRowsItem: false,
              selectAllRowsItemText: "Selectionner toutes les actions",
            }}
            data={dataactions}
          />
          {redirecting}
        </GridItem>
      </GridContainer>
    </>
  );
}
